var exports = {
  "iE": "x127c5a35--14d0b9--wrapper",
  "kL": "x127c5a35--14d0b9--container",
  "DD": "x127c5a35--14d0b9--title",
  "E1": "x127c5a35--14d0b9--scrollable",
};

module.exports = exports;
